import { useTranslation } from "react-i18next";

interface TextProps {
  text: string;
  className?: string;
  translate?: boolean;
  size?: number;
  linkify?: boolean;
}

const URL_PATTERN = /(https?:\/\/[^\s]+)/g;

const renderWithLinks = (text: string) =>
  text.split(URL_PATTERN).map((part, index) =>
    /^https?:\/\//.test(part) ? (
      <a
        key={`link-${index}`}
        href={part}
        target="_blank"
        rel="noopener noreferrer"
        className="text-link"
      >
        {part}
      </a>
    ) : (
      part
    )
  );

const Text: React.FC<TextProps> = ({
  text,
  className,
  translate = true,
  size = 15,
  linkify = false,
}) => {
  const { t } = useTranslation();
  const content = translate ? t(text) : text;
  return (
    <div
      className={`text-default${className ? ` ${className}` : ""}`}
      style={{ fontSize: `${size}px` }}
    >
      {linkify ? renderWithLinks(content) : content}
    </div>
  );
};

export default Text;
